/* eslint-disable no-param-reassign, no-shadow, camelcase */
import Vuex from 'vuex'
import plugins from './plugins'
import * as actions from './actions'

const state = {
  userId: null,
  contexteId: null,
}

const mutations = {
  USER_REGISTER (state, { id, context_id }) {
    state.userId = id
    state.contexteId = context_id
  },
  USER_RESET (state) {
    state.userId = null
    state.contexteId = null
  },
}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  plugins,
  getters: {
    userId: ({ userId }) => userId,
    contexteId: ({ contexteId }) => contexteId,
  },
})



// WEBPACK FOOTER //
// ./src/vuex/store.js